

// 生成json，排除指定字段
export function toJSONExcludes(obj, excludes) {
    var json = {};
    for (var key in obj) {
        if (excludes != key) {
            var subObj = obj[key];
            if (isObject(subObj)) {
                json[key] = toJSONExcludes(subObj, excludes);
            } else {
                json[key] = obj[key];
            }
        }else{
            console.log("keyb",key,"被排除")
        }
    }
    return json;
}

// 生成json，排除指定字段,并转换成json字符串
export function toJSONStringExcludes(obj, excludes) {
    return JSON.stringify(toJSONExcludes(obj, excludes));
}

export function isObject(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}